export function MockCard({
  children,
  className = '',
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm select-none ${className}`}
    >
      {children}
    </div>
  )
}

export function MockKpiCard({
  value,
  label,
  color = 'brand',
}: {
  value: string
  label: string
  color?: string
}) {
  // Реальные KPI-карточки дашборда (ManagerKpiCards / ProcurementKpiCards)
  // не содержат эмодзи — только цветной фон, значение и подпись.
  // Моки в «Базе знаний» должны соответствовать этому стилю.
  const bgMap: Record<string, string> = {
    brand: 'bg-brand-50 dark:bg-brand-900/20',
    green: 'bg-green-50 dark:bg-green-900/20',
    red: 'bg-red-50 dark:bg-red-900/20',
    orange: 'bg-orange-50 dark:bg-orange-900/20',
    blue: 'bg-blue-50 dark:bg-blue-900/20',
  }
  return (
    <div className={`${bgMap[color] ?? bgMap.brand} rounded-xl p-4 select-none`}>
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">{label}</div>
      <div className="text-2xl font-bold text-gray-900 dark:text-gray-100 tabular-nums">
        {value}
      </div>
    </div>
  )
}

export function MockInput({
  label,
  value,
  placeholder,
}: {
  label: string
  value?: string
  placeholder?: string
}) {
  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      <div className="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 select-none">
        {value || <span className="text-gray-400">{placeholder ?? ''}</span>}
      </div>
    </div>
  )
}

export function MockSelect({ label, value }: { label: string; value: string }) {
  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      <div className="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 flex items-center justify-between select-none">
        <span>{value}</span>
        <span className="text-gray-400 text-xs">▼</span>
      </div>
    </div>
  )
}

export function MockButton({
  children,
  variant = 'primary',
}: {
  children: string
  variant?: 'primary' | 'secondary' | 'danger'
}) {
  const cls = {
    primary: 'bg-brand-600 text-white',
    secondary:
      'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600',
    danger: 'bg-red-600 text-white',
  }
  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 text-sm rounded-lg font-medium select-none ${cls[variant]}`}
    >
      {children}
    </span>
  )
}

export function MockSearchInput({ placeholder = 'Поиск...' }: { placeholder?: string }) {
  return (
    <div className="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-400 dark:text-gray-500 bg-white dark:bg-gray-800 min-w-[200px] select-none">
      {placeholder}
    </div>
  )
}

export function MockLink({ children }: { children: string }) {
  return (
    <span className="text-brand-600 dark:text-brand-400 font-medium select-none">{children}</span>
  )
}

export function MockWarning({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-3 py-2 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg text-xs text-amber-800 dark:text-amber-300 select-none">
      {children}
    </div>
  )
}
